import { useEffect } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Lenis from 'lenis'

import LPNavigation from './sections/LPNavigation'
import HeroSection from './sections/HeroSection'
import StatsBar from './sections/StatsBar'
import DashboardShowcase from './sections/DashboardShowcase'
import FeaturesGrid from './sections/FeaturesGrid'
import SecuritySection from './sections/SecuritySection'
import MobileShowcase from './sections/MobileShowcase'
import TestimonialsSection from './sections/TestimonialsSection'
import PricingSection from './sections/PricingSection'
import FAQSection from './sections/FAQSection'
import CTABanner from './sections/CTABanner'
import LPFooter from './sections/LPFooter'
import ScrollToTop from './sections/ScrollToTop'

gsap.registerPlugin(ScrollTrigger)

export default function LandingPage() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08 })

    const onScroll = () => ScrollTrigger.update()
    lenis.on('scroll', onScroll)

    const ticker = (time) => lenis.raf(time * 1000)
    gsap.ticker.add(ticker)
    gsap.ticker.lagSmoothing(0)

    return () => {
      lenis.off('scroll', onScroll)
      lenis.destroy()
      gsap.ticker.remove(ticker)
    }
  }, [])

  return (
    <div className="min-h-screen bg-warm-stone">
      <ScrollToTop />
      <LPNavigation />
      <HeroSection />
      <StatsBar />
      <DashboardShowcase />
      <FeaturesGrid />
      <SecuritySection />
      <MobileShowcase />
      <TestimonialsSection />
      <PricingSection />
      <FAQSection />
      <CTABanner
        headline="Ready to start building passive income?"
        subtext="Join thousands of investors already tracking their dividends. Free plan forever — no credit card needed."
        ctaText="Start Free Today"
        microcopy="Free plan forever · No credit card required"
      />
      <LPFooter />
    </div>
  )
}
